/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
          $('.regiter-please').on('click', function(e){
              e.preventDefault();
              $(this).hide();
              $('.login-screen').toggleClass('active');
              $('.register-screen').toggleClass('active');
            });

           $('.menu-icon').on('click', function(){
                $(this).toggleClass('opened-menu');
                $('.mobile-nav').toggleClass('opened-nav');
            });
      $('.redirectohome').on('click', function(){
                window.location.href = "/";
            });
           

           $('.scroll').on("click", function(e) {

              e.preventDefault();

              var dest = $(this).attr("href");

              $("html, body").animate({

                'scrollTop':   $(dest).offset().top

              }, 2000);

            });


     
    //Isotope activation js codes
   /* var $gellary_img = $('.gallery-items').isotope({
      itemSelector: '.gallery-item',
      percentPosition: true,
      transitionDuration: '0.5s',
      masonry: {
      // use outer width of grid-sizer for columnWidth
      columnWidth: '.gallery-item',
      gutter: 30
      },
      getSortData: {
      name: '.name',
      symbol: '.symbol',
      number: '.number parseInt',
      category: '[data-category]',
      weight: function( itemElem ) {
        var weight = $( itemElem ).find('.weight').text();
        return parseFloat( weight.replace( /[\(\)]/g, '') );
      }
      }
    });
  */

    // filter functions
    var filterFns = {
      // show if number is greater than 50
      numberGreaterThan50: function() {
      var number = $(this).find('.number').text();
      return parseInt( number, 10 ) > 50;
      },
      // show if name ends with -ium
      ium: function() {
      var name = $(this).find('.name').text();
      return name.match( /ium$/ );
      }
    };

    // bind filter button click
    $('.gallery-menu').on( 'click', 'li', function() {
      var filterValue = $( this ).attr('data-filter');
      // use filterFn if matches value
      filterValue = filterFns[ filterValue ] || filterValue;
     // $gellary_img.isotope({ filter: filterValue });
    });


    // change is-checked class on buttons
    $('.gallery-menu').each( function( i, liList ) {
      var $liList = $( liList );
      $liList.on( 'click', 'li ', function() {
      $liList.find('.active').removeClass('active');
      $( this ).addClass('active');
      });
    }); 
  

           
           
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

         $(".navbar a").on('click', function (event) {
         
         $( "#navbarNavDropdown" ).toggleClass( "show" );
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
          // Prevent default anchor click behavior
          event.preventDefault();

          // Store hash
          var hash = this.hash;

          // Using jQuery's animate() method to add smooth page scroll The optional number
          // (800) specifies the number of milliseconds it takes to scroll to the
          // specified area
          $('html, body').animate({
              scrollTop: $(hash)
                  .offset()
                  .top
          }, 800, function () {

              // Add hash (#) to URL when done scrolling (default click behavior)
              window.location.hash = hash;
          });
      } // End if
  });
        // JavaScript to be fired on the home page
/* $('.panel-heading').on('click', function(e){
        $(this).next(".panel-collapse").toggleClass('show');
  });
      */
$('.jobapplication').on('click', function(e){
    $(".jobrole input").val($(this).attr('role'));
});
      
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
          $(".navbar a").on('click', function (event) {

      alert(this.hash);
  });
      }
    },
    'shop': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
